import React from 'react';
import { Tabs } from 'antd';
import Groups from './group/index';
import Ecs from './ecs';
import Provider from './provider';

const FlexGroup = () => {
  return (
    <div style={{ width: '100%', height: '100%', padding: 12 }}>
      <Tabs
        defaultActiveKey="1"
        destroyInactiveTabPane={true}
        items={[
          {
            label: 'Groups',
            key: '1',
            children: <Groups />,
          },
          {
            label: 'Ecs',
            key: '2',
            children: <Ecs />,
          },
          {
            label: 'Providers',
            key: '3',
            children: <Provider />,
          },
        ]}
      />
    </div>
  );
};

export default FlexGroup;
